export default function Node_Events() {
  return <div>Node_Events Component</div>;
}
